import { useEffect } from 'react';

const CHUNK_KEY = '@cte:chunk-reload';
const PATTERN = /ChunkLoadError|Loading chunk .* failed|Loading CSS chunk/;

/**
 * Um deploy remove os chunks antigos do servidor. Uma aba que ainda esta com o index.html
 * anterior pede um chunk que nao existe mais e recebe 404 (ver `try_files $uri =404` no
 * bloco /static/ de .ci/default.conf), o que faz o webpack lancar ChunkLoadError. Como
 * src/router.tsx usa lazy() em 60 rotas, isso deixa a rota em branco.
 *
 * Um unico reload resolve, porque traz o index.html novo apontando para os chunks novos.
 *
 * A flag guarda o SHA do bundle que falhou, e nao um booleano: se o reload NAO trocou de
 * bundle, o 404 e real (bug de build) e insistir viraria loop de reload. Guardando o SHA,
 * paramos em uma tentativa por bundle, e um deploy futuro (SHA novo) volta a habilitar a
 * recuperacao automaticamente.
 */
const useChunkRecovery = () => {
  useEffect(() => {
    const build = process.env.REACT_APP_GIT_SHA || 'dev';

    const onChunkError = (event: Event) => {
      const message = String(
        (event as PromiseRejectionEvent).reason || (event as ErrorEvent).message || ''
      );
      let assetUrl = '';
      if (event.target instanceof HTMLScriptElement) {
        assetUrl = event.target.src;
      } else if (event.target instanceof HTMLLinkElement) {
        assetUrl = event.target.href;
      }
      if (!PATTERN.test(message) && !/\/static\/(?:js|css)\//.test(assetUrl)) return;

      let alreadyTried = '';
      try {
        alreadyTried = sessionStorage.getItem(CHUNK_KEY) || '';
      } catch (e) {
        return; // sessionStorage indisponivel: sem contador, nao arrisca recarregar
      }
      if (alreadyTried === build) return; // ja tentamos neste bundle -> 404 real

      try {
        sessionStorage.setItem(CHUNK_KEY, build);
      } catch (e) {
        return;
      }
      window.location.reload();
    };

    // Falha de carregamento de recurso nao borbulha: precisa da fase de captura.
    window.addEventListener('error', onChunkError, true);
    window.addEventListener('unhandledrejection', onChunkError);

    return () => {
      window.removeEventListener('error', onChunkError, true);
      window.removeEventListener('unhandledrejection', onChunkError);
    };
  }, []);
};

export default useChunkRecovery;
